import React, { useEffect, useState } from "react";
import { apiGet } from "../../Utils/apiFetch";

const StreamingPlayer = ({ eventId, isLoaded, setIsLoaded, setControls }) => {
  const [streamUrl, setStreamUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  console.log("------------------>");

  const getStreamingUrl = async (eventId) => {
    setLoading(true);
    setError("");

    try {
      const { data } = await apiGet(
        `https://kurukwin.xyz/sumit-api/exchange/member/playerService/getStreamingUrlByEventId?eventId=${eventId}&isPopup=false`,
      );

      console.log("Response:", data);

      // API Error
      if (data?.status === false) {
        setStreamUrl("");
        setError(data.message || "Unable to load stream.");
        return;
      }

      // Success
      if (data?.streamingUrl?.trim()) {
        setStreamUrl(data.streamingUrl);
        return;
      }

      // Empty URL
      setStreamUrl("");
      setError("Streaming is not available for this event.");
    } catch (err) {
      console.error(err);
      setStreamUrl("");
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (eventId) {
      getStreamingUrl(eventId);
    }
  }, [eventId]);
  return (
    <div>
      {/* {loading && <p>Loading stream...</p>} */}

      {/* {error && <p style={{ color: "red" }}>{error}</p>} */}

      <iframe
        // onClick={() => setControls(true)}
        title="Live TV Player"
        src={streamUrl}
        id="ContentPlaceHolder1_myFrame1"
        onLoad={() => setIsLoaded(true)}
        style={{
          //   position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "233px",
          border: "none",
          overflow: "none",
          opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
        }}
        className="sc-dUjcNx eLUYUT"
      />
    </div>
  );
};

export default StreamingPlayer;
